import React from "react";
import { ISubscriptionData } from "../../services/dashboard.services";
import PlanDataItemLayout from "./PlanDataItemLayout";
import { Box, Button, Divider, Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { setSelectedSubscription } from "./dashboardSlice";
import { useHistory } from "react-router-dom";
import { Views } from "../../helpers/constants";
import { useTranslation } from "react-i18next";

// Component styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginButton: {
      width: "180px",
      height: "35px",
    },
    buttonText: {
      color: theme.palette.dark.light,
      fontSize: "0.8rem",
    },
    subscriptionContainer: {
      width: "75%",
      marginBottom: "40px",
    },
    itemDividerBox: {
      marginBottom: "20px",
      width: "75%",
    },
    itemDivider: {
      backgroundColor: theme.palette.dark.main,
    },
    updatePlanButton: {
      display: "flex",
      justifyContent: "end",
    },
    planTitleContainer: {
      width: "75%",
      marginBottom: "8px",
    },
    planNumber: {
      fontSize: "0.75rem",
    },
    planDate: {
      fontSize: "0.75rem",
      textAlign: "end",
    },
    primaryEmail: {
      fontSize: "0.70rem",
      color: theme.palette.gray.main,
    },
  })
);

export function getPlanDateString(epochDate: number) {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  var date = new Date(epochDate * 1000);
  let month = date.getMonth();
  let day = date.getDate();
  let year = date.getFullYear();

  return months[month] + " " + day + ", " + year;
}

export default function PlanData(props: IProps) {
  const {
    subscription_items,
    primary_email,
    is_primary_user,
  } = props.subscriptionData;
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const planStartDate = getPlanDateString(props.subscriptionData.start_date);

  const handleUpdatePlan = () => {
    dispatch(setSelectedSubscription(props.subscriptionData));
    history.push(Views.SUBSCRIPTION_MANAGEMENT);
  };

  return (
    <React.Fragment>
      <Grid container className={classes.planTitleContainer}>
        <Grid item xs={9}>
          <Grid container className={classes.planTitleContainer}>
            <Grid item xs={3}>
              <Typography className={classes.planNumber}>
                {t("plan_number") + " " + props.itemIndex}
              </Typography>
            </Grid>
            {!is_primary_user && (
              <Grid item xs={6}>
                <Typography className={classes.primaryEmail}>
                  {t("primary_email", {
                    email: primary_email,
                  })}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Typography className={classes.planDate}>
            {t("plan_start") + " " + planStartDate}
          </Typography>
        </Grid>
      </Grid>

      <Box className={classes.itemDividerBox}>
        <Divider className={classes.itemDivider} />
      </Box>
      <Grid container className={classes.subscriptionContainer}>
        <Grid item xs={6}>
          {subscription_items &&
            subscription_items.map((subItem) => {
              return (
                <PlanDataItemLayout
                  key={subItem.id}
                  id={subItem.id}
                  quantity={subItem.quantity}
                  product={subItem.product}
                  productID={subItem.product_id}
                ></PlanDataItemLayout>
              );
            })}
        </Grid>
        <Grid item xs={6} className={classes.updatePlanButton}>
          <Button
            type="submit"
            variant="outlined"
            size="large"
            className={classes.loginButton}
            onClick={handleUpdatePlan}
          >
            <Typography className={classes.buttonText}>Update Plan</Typography>
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

interface IProps {
  subscriptionData: ISubscriptionData;
  itemIndex: number;
  primaryEmail?: string;
  isPrimaryUser?: boolean;
}
